export const messagesTitles = {
  requestWasCancelled: 'Заявка отменена',
  counterofferHasBeenSent: 'Ваше встречное предложение отправлено',
}
